import { render } from "./Problematique.vue?vue&type=template&id=124b83e8"
import script from "./Problematique.vue?vue&type=script&lang=js"
export * from "./Problematique.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__